import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
import { lineShape } from './line-shape.js';
import { lowercaseUuid } from './lowercase-uuid.js';
import { refineCustomerPaidWithinPrice } from './refine-customer-paid-within-price.js';
// A line without an id is added, and an existing line left out of the edit is removed.
export const promotionCreditLineUpdateInputSchema = z
    .object({
    id: optionalUuidString('Invalid credit line.')
        .nullish()
        .transform((value) => (typeof value === 'string' ? lowercaseUuid(value) : value)),
    ...lineShape,
})
    .superRefine(refineCustomerPaidWithinPrice);
//# sourceMappingURL=line-update-input.js.map